module.exports = __webpack_public_path__ + "static/media/manualTouch.7dd50528.svg";